import {
  AlertMovementReasons,
  AlertMovementReasonsLabels,
  ReportStatus,
} from '@/generated/enums'
import { unSnakeCase } from '@/utils/string_utils'

const QUEUES_TO_MONITOR_BETWEEN = [
  ReportStatus.ARCHIVED, // Archived
  ReportStatus.NEEDS_REVIEW, // DR
  ReportStatus.NO_ACTION, // Monitoring
  ReportStatus.INTERNAL_IGNORED, // IBM
  ReportStatus.NEEDS_ACTION, // NC
]

// Helper function to create consistent string keys from two ReportStatus values
export const createQueueMovementKey = (
  fromStatus: ReportStatus,
  toStatus: ReportStatus,
): string => {
  return `${fromStatus}_${toStatus}`
}

export const getDescriptionForReason = (reason: AlertMovementReasons): string => {
  return unSnakeCase(AlertMovementReasonsLabels[reason])
}

const QUEUE_MOVEMENTS_TO_VALID_REASONS = new Map<string, AlertMovementReasons[]>([
  [
    createQueueMovementKey(ReportStatus.NEEDS_REVIEW, ReportStatus.INTERNAL_IGNORED),
    [
      AlertMovementReasons.UNRELATED_TO_ENTITY,
      AlertMovementReasons.SIMILAR_OTHER_BRAND,
    ],
  ],
  [
    createQueueMovementKey(ReportStatus.NEEDS_REVIEW, ReportStatus.ARCHIVED),
    [
      AlertMovementReasons.CUSTOMER_OWNED_SITE,
      AlertMovementReasons.CUSTOMER_AFFILIATED_SITE,
      AlertMovementReasons.RUBRIC_POLICY,
    ],
  ],
  [
    createQueueMovementKey(ReportStatus.NEEDS_REVIEW, ReportStatus.NO_ACTION),
    [
      AlertMovementReasons.FUTURE_RISK_SITE,
      AlertMovementReasons.RUBRIC_POLICY,
      AlertMovementReasons.DUPLICATE,
    ],
  ],
  [
    createQueueMovementKey(ReportStatus.NEEDS_REVIEW, ReportStatus.NEEDS_ACTION),
    [
      AlertMovementReasons.POTENTIAL_CUSTOMER_OWNED_SITE,
      AlertMovementReasons.POTENTIAL_CUSTOMER_AFFILIATED_SITE,
      AlertMovementReasons.RUBRIC_POLICY,
    ],
  ],
  [
    createQueueMovementKey(ReportStatus.NEEDS_ACTION, ReportStatus.ARCHIVED),
    [AlertMovementReasons.CUSTOMER_OWNED_SITE, AlertMovementReasons.CUSTOMER_REQUEST],
  ],
  [
    createQueueMovementKey(ReportStatus.NEEDS_ACTION, ReportStatus.NO_ACTION),
    [AlertMovementReasons.DOWN_BEFORE_REVIEW, AlertMovementReasons.FUTURE_RISK_SITE],
  ],
  [
    createQueueMovementKey(ReportStatus.NO_ACTION, ReportStatus.NEEDS_REVIEW),
    [AlertMovementReasons.REVIVED],
  ],
  [
    createQueueMovementKey(ReportStatus.RESOLVED, ReportStatus.NEEDS_REVIEW),
    [AlertMovementReasons.REVIVED],
  ],
])

export { QUEUES_TO_MONITOR_BETWEEN, QUEUE_MOVEMENTS_TO_VALID_REASONS }
